var map = {
	"./auth/route.json": 56849,
	"./billing/route.json": 44302,
	"./cam/route.json": 14918,
	"./care-sheet/route.json": 58120,
	"./certificate/route.json": 74426,
	"./consultation/route.json": 81678,
	"./dental-consultation/route.json": 28695,
	"./exam/route.json": 5884,
	"./example-module/route.json": 15278,
	"./forms/route.json": 91158,
	"./frontdesk/route.json": 82603,
	"./general-payment/route.json": 97226,
	"./generic-states/route.json": 70753,
	"./hospitalization/route.json": 84755,
	"./medical-care/route.json": 27564,
	"./oximetry/route.json": 13998,
	"./parameters/route.json": 39163,
	"./patient/route.json": 73888,
	"./payment/route.json": 5691,
	"./prescription/route.json": 75343,
	"./rehabilitation/route.json": 79074,
	"./shared/route.json": 90670,
	"./specifics/route.json": 95952,
	"./stock/route.json": 59167,
	"./visit/route.json": 49566,
	"./workflow/route.json": 17474,
	"auth/route.json": 56849,
	"billing/route.json": 44302,
	"cam/route.json": 14918,
	"care-sheet/route.json": 58120,
	"certificate/route.json": 74426,
	"consultation/route.json": 81678,
	"dental-consultation/route.json": 28695,
	"exam/route.json": 5884,
	"example-module/route.json": 15278,
	"forms/route.json": 91158,
	"frontdesk/route.json": 82603,
	"general-payment/route.json": 97226,
	"generic-states/route.json": 70753,
	"hospitalization/route.json": 84755,
	"medical-care/route.json": 27564,
	"oximetry/route.json": 13998,
	"parameters/route.json": 39163,
	"patient/route.json": 73888,
	"payment/route.json": 5691,
	"prescription/route.json": 75343,
	"rehabilitation/route.json": 79074,
	"shared/route.json": 90670,
	"specifics/route.json": 95952,
	"stock/route.json": 59167,
	"visit/route.json": 49566,
	"workflow/route.json": 17474
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3078;